import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-splitpayment',
  templateUrl: './splitpayment.component.html',
  styleUrls: ['./splitpayment.component.css']
})
export class SplitpaymentComponent implements OnInit {

  @Output() cancel_payment = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }
  cancelPayment() {
    this.cancel_payment.emit();
  }


}
